import { render, staticRenderFns } from "./MenuSections.vue?vue&type=template&id=5eae8fa5&"
import script from "./MenuSections.vue?vue&type=script&lang=js&"
export * from "./MenuSections.vue?vue&type=script&lang=js&"
import style0 from "./MenuSections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports